<template>
  <div class="country-issue">
    <el-form
      :model="form"
      label-width="150px"
      ref="issueForm"
      class="issue-form"
    >
      <el-form-item
        label="请输入用户手机号"
        prop="phone"
        :rules="[
          { required: true, message: '请输入用户手机号', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ]"
      >
        <div class="input-container">
          <div class="input-wrapper">
            <el-input v-model="form.phone" placeholder="请输入"></el-input>
          </div>
          <!-- <el-button type="primary" @click="checkUserInfo" class="check-btn"
            >查看用户信息</el-button
          > -->
        </div>
      </el-form-item>

      <el-form-item
        label="国版币"
        prop="amount"
        :rules="[
          { required: true, message: '请输入国版币数量', trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' },
        ]"
      >
        <div class="input-wrapper">
          <el-input
            v-model.number="form.amount"
            placeholder="请输入"
          ></el-input>
        </div>
      </el-form-item>

      <el-form-item
        label="实付金额"
        prop="actualAmount"
        :rules="[
          { required: true, message: '请输入实付金额', trigger: 'blur' },
          { validator: validateActualAmount, trigger: 'blur' },
        ]"
      >
        <div class="input-wrapper">
          <el-input v-model="form.actualAmount" placeholder="请输入"></el-input>
        </div>
      </el-form-item>

      <el-form-item label="备注">
        <div class="input-wrapper">
          <el-input
            type="textarea"
            v-model="form.remark"
            placeholder="请输入线下打款信息等"
            :rows="4"
          ></el-input>
        </div>
      </el-form-item>

      <el-form-item>
        <div class="btn-container">
          <el-button @click="resetForm">取消</el-button>
          <el-button
            type="primary"
            @click="handleSubmit"
            :loading="submitLoading"
            >确定</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { certificationByPhone } from "@/api/package";
import { grant } from "@/api/menu";

export default {
  name: "CountryIssue",
  data() {
    return {
      form: {
        phone: "",
        amount: "",
        actualAmount: "",
        remark: "",
      },
      submitLoading: false,
    };
  },
  methods: {
    validateAmount(rule, value, callback) {
      if (
        value &&
        (value < 0 || value > 99999 || !Number.isInteger(Number(value)))
      ) {
        callback(new Error("数量需为大于>0且≤99999的正整数"));
      } else {
        callback();
      }
    },
    validateActualAmount(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }

      const num = Number(value);
      if (isNaN(num)) {
        callback(new Error("请输入有效的数字"));
        return;
      }

      if (num <= 0 || num > 99999) {
        callback(new Error("金额需为大于0且≤99999的数字"));
        return;
      }

      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("最多支持两位小数"));
        return;
      }

      if (this.form.amount && num > Number(this.form.amount)) {
        callback(new Error("实付金额需小于或等于国版币"));
        return;
      }

      callback();
    },
    async checkUserInfo() {
      if (!this.form.phone) {
        this.$message.warning("请先输入手机号");
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }

      try {
        const { data } = await this.$ajax.get(
          certificationByPhone(this.form.phone)
        );
        if (data?.code === 200) {
          if (data.data.state !== "CERTIFIED") {
            this.$message.warning("该用户未进行身份认证或认证未通过");
            return;
          }
          sessionStorage.setItem("currentUserInfo", JSON.stringify(data.data));
          this.$message.success("用户信息查询成功");
        } else {
          this.$message.warning(data?.msg || "该用户未注册");
        }
      } catch (error) {
        this.$message.error("查询用户信息失败");
      }
    },
    resetForm() {
      this.$refs.issueForm.resetFields();
      this.form = {
        phone: "",
        amount: "",
        actualAmount: "",
        remark: "",
      };
    },
    async handleSubmit() {
      this.$refs.issueForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          try {
            const { data } = await this.$ajax.get(
              certificationByPhone(this.form.phone)
            );
            if (data?.code !== 200) {
              this.$message.warning(data?.msg || "该用户未注册");
              return;
            }
            if (data.data.state !== "CERTIFIED") {
              this.$message.warning("该用户未进行身份认证或认证未通过");
              return;
            }
            sessionStorage.setItem(
              "currentUserInfo",
              JSON.stringify(data.data)
            );

            try {
              await this.$confirm(
                "发放成功后，用户账户将拥有该国版币，确认发放?",
                "发放",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              );

              const params = {
                count: this.form.amount,
                payPrice: this.form.actualAmount,
                phone: this.form.phone,
                remark: this.form.remark,
              };

              const res = await this.$ajax.post(grant, params);
              if (res.data?.code === 200) {
                this.$message.success("发放成功");
                this.resetForm();
              } else {
                this.$message.error(res.data?.msg || "发放失败");
              }
            } catch (error) {
              if (error === "cancel") {
                this.$message.info("已取消发放");
              } else {
                this.$message.error("发放失败");
              }
            }
          } catch (error) {
            this.$message.error("验证用户信息失败");
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
  },
  watch: {
    "form.amount": {
      handler(newVal) {
        if (newVal && this.form.actualAmount) {
          this.$refs.issueForm.validateField("actualAmount");
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.country-issue {
  padding: 20px;
  background: #ffffff;

  .issue-form {
    max-width: 800px;
  }

  .input-wrapper {
    width: 320px;
  }

  .input-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .check-btn {
    white-space: nowrap;
  }

  .btn-container {
    margin-left: -150px;
    text-align: center;

    .el-button {
      min-width: 80px;
    }
  }

  :deep(.el-form-item__label) {
    font-weight: normal;
    line-height: 32px;
  }

  :deep(.el-textarea__inner) {
    min-height: 100px !important;
  }
}
</style>
